// Copyright (c) 2019 Deere & Company

import './index.scss';

import AuthenticatedPage from '../app/common/components/authenticated-page';
import Home from './components/home';
import React from 'react';

const HomePage = () => (

    <AuthenticatedPage className="home-page">
        <Home />
    </AuthenticatedPage>

);

export default HomePage;
